import * as React from 'react';

import type { HeadProps, PageProps } from 'gatsby';
import { StaticImage } from 'gatsby-plugin-image';

import { CtaBlock } from 'stile-shared/src/components/2020/blocks/CtaBlock';

import { PageLayout } from 'templates/2024/PageLayout';
import { SEO } from 'templates/2024/SEO';

import { ResourceAccessBlock } from 'components/common/ResourceAccessBlock';

export function Head(props: HeadProps) {
  return (
    <SEO
      title="Western Australian Curriculum"
      description="2025 teacher planning resource"
      slug={props.location.pathname}
    />
  );
}

function WACurriculumPage(props: PageProps) {
  return (
    <PageLayout {...props}>
      <ResourceAccessBlock
        title="Western Australian Curriculum"
        subtitle="2025 teacher planning resource"
        id="WA_CURRICULUM"
        redirectUrl="https://stileapp.com/go/wa2025"
        image={
          <StaticImage src="../../../../stile-shared/assets/images/resources/wa_2025.png" alt="" />
        }
      >
        <p>
          Stile is a complete, coherent curriculum for Australian science classrooms. This Scope and
          Sequence is aligned to the Western Australian Curriculum.
        </p>
        <p>
          It offers a world-class starting point for designing your school’s science curriculum. It
          can be used in its current format alongside our comprehensive teaching plan, or it can be
          customised to best suit your unique context.
        </p>
      </ResourceAccessBlock>

      <CtaBlock />
    </PageLayout>
  );
}

export default WACurriculumPage;
